import { Button } from "@progress/kendo-react-buttons"
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns"
import React, { Fragment, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { getAlarmsLoadingSelector, getAlarmsLoadingSelectorWithScope, getAlarmsWithScopeSelector } from "../Alarms/Slice"
import { getOptionsSelector, updateAlarmsVisibility, updateChartItemNumber, updateMachineTimesSortOrder } from "../Common/Slices/optionSlice"
import { useAppDispatch } from "../Core/store.hooks"
import { getMachineTimesLoadingSelector } from "./slice"


const sortOrderOptions = 
    ["Shift Length",
    "Running Hours",
    "Failure Hours",
    "Failure Timeout",
    "Idle after Running",
    "Idle after Failure",
    "Failure to running %",
    "Failure to Shift %"]
const itemNumberOptions = [10,20,30,40,"All"]

const ChartOptions = () =>{
    const [itemNumber, setItemNumber] = useState(itemNumberOptions[0])
    const [sortOrder, setSortOrder] = useState(sortOrderOptions[0])
    const [buttonDisabled, setButtonDisabled] = useState(true);


    const options = useSelector(getOptionsSelector)

    const alarmData = useSelector(getAlarmsWithScopeSelector)
    const alarmsLoading = useSelector(getAlarmsLoadingSelectorWithScope)
    const machineTimesLoading = useSelector(getMachineTimesLoadingSelector)
    
    const dispatch = useAppDispatch();

    useEffect(()=>{
        setItemNumber(options.chartItemNumber)
    },[])

    useEffect(() => {
        if (alarmData == null) {
            setButtonDisabled(true)
        }
        else if(alarmData.length > 0 && alarmsLoading !== "pending" && machineTimesLoading !== "pending"){
            setButtonDisabled(false);
        }else if(alarmData.length == 0 && alarmsLoading === "fulfilled"){
            setButtonDisabled(false);
        }else{
            setButtonDisabled(true)
        }
    },[alarmData,alarmsLoading,machineTimesLoading])

    const handleItemNumber = (e:DropDownListChangeEvent) =>{
        setItemNumber(e.target.value)
        if(e.target.value === "All"){
            dispatch(updateChartItemNumber(0))
        }else{
            dispatch(updateChartItemNumber(e.target.value))
        }
    }

    const handleSortOrder = (e:DropDownListChangeEvent) =>{
        setSortOrder(e.target.value)
        dispatch(updateMachineTimesSortOrder(e.target.value))
    }

    const handleAlarms = () =>{
        dispatch(updateAlarmsVisibility(!options.alarmsVisibility))
    }

    return (
        <Fragment>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Number Of Items</label>
                <DropDownList
                    data={itemNumberOptions}
                    value={itemNumber}
                    onChange={handleItemNumber}
                />
            </div>

            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Sort Order</label>
                <DropDownList
                    popupSettings={{width:"auto"}}
                    data={sortOrderOptions}
                    value={sortOrder}
                    onChange={handleSortOrder}
                />
            </div>

            {/* <div className="k-textbox-container metricCombo">
                <button
                    style={{
                        height: "30px",
                        marginTop: "2px",
                        borderRadius: "0px",
                    }}
                    className="btn btn-primary btn-md  pp-inlineB"
                    //onClick={() => paramsHandler()}
                >
                    UPDATE
                </button>
            </div> */}

            <div>
                <Button
                style={{width:"95%",marginTop:"5px"}}
                disabled={buttonDisabled}
                onClick={handleAlarms}
                >
                {options.alarmsVisibility ? "Hide Alarms": "Show Alarms"}
                {buttonDisabled && <img style={{height:"15px",width:"auto"}} src="assets/img/spinner.gif" />}
                </Button>
            </div>
        </Fragment>
    )
}
export default ChartOptions;